'use client';
import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';

export const isDrawerOpenAtom = atom(false);

export function useDrawer() {
	const [isDrawerOpen, setIsDrawerOpen] = useAtom(isDrawerOpenAtom);

	const openDrawer = useCallback(() => setIsDrawerOpen(true), [setIsDrawerOpen]);
	const closeDrawer = useCallback(() => setIsDrawerOpen(false), [setIsDrawerOpen]);
	const toggleDrawer = useCallback(() => setIsDrawerOpen(value => !value), [setIsDrawerOpen]);

	return {
		closeDrawer,
		isDrawerOpen,
		openDrawer,
		toggleDrawer
	};
}
